import styled, { css } from 'styled-components';
import { Image } from 'ui/Image';
import { Link } from 'ui/Link';

export const WrapAuthor = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-bottom: 45px;
  :last-of-type {
    margin-bottom: 0;
  }
  ${({ theme }) => css`
    ${theme.media.tabletS} {
      display: none;
    }
  `};
`;

export const AuthorImg = styled(Image)`
  width: 175px;
  height: 175px;
  background-color: #d7d7d7;
  margin-bottom: 35px;
  border-radius: 50%;
  img {
    border-radius: 50%;
    object-fit: cover !important;
  }
  ${({ theme }) => css`
    ${theme.media.tabletS} {
      margin-bottom: 20px;
    }
    ${theme.media.mobileM} {
      width: 140px;
      height: 140px;
      margin-bottom: 10px;
    }
  `};
`;

export const AuthorName = styled.p`
  font-family: cormorant-garamond, serif;
  font-weight: 500;
  font-size: 27px;
  line-height: 32px;
  margin-bottom: 10px;
  text-align: center;
  ${({ theme }) => css`
    ${theme.media.mobileM} {
      font-size: 22px;
      line-height: 28px;
    }
  `};
`;

export const AuthorOtherMaterials = styled(Link)`
  font-family: lato, sans-serif;
  font-weight: 400;
  font-size: 15px;
  line-height: 24px;
  color: #b2b2b2;
  text-transform: uppercase;
  text-decoration: none;
  cursor: pointer;
  :hover {
    text-decoration: underline;
    color: #b2b2b2;
  }
  ${({ theme }) => css`
    ${theme.media.mobileM} {
      font-size: 13px;
      line-height: 16px;
    }
  `};
`;
